<template>
  <div class="question-box" :class="{'question-single':single}">
    <!-- show QA box -->

    <!-- <div class="question-info mb-lg-4" v-if="!finish2">
    <div class="ml-2 pl-3 text-dark text-center col-12 col-lg-7 mx-auto pt-4">
      <div class="d-inline-block border p-3">
        <div class="py-1">本試題為單一選擇題，請選出一個正確或最適當的答案，複選作答者，該題不予計分。</div>
        <div class="py-1">本科目共 {{totalQuestion}} 題，每題 {{(100/totalQuestion).toFixed(2)}} 分</div>
      </div>
    </div>
  </div> -->
    <div class="question-exam overflow-auto" v-for="(item, index) in questions" :key="index"
      :class="{ active:getactive(proqkey2,index + 1,item)}">
      <!-- <div v-html="item.art"></div> -->
      <b-card no-body class="mx-lg-4 pt-4 pb-3 border-0" v-if="item.fill || item.read">
        <b-row no-gutters class="align-items-center">
          <div class='col-12 px-3 px-md-4 bg-white' v-html='(item.fill || item.read).art'>
          </div>
          <div class="col-12" v-for='items in (item.fill || item.read).data'
            v-show='getfillquestion(items.questionnumber)'>
            <!-- =========================== -->
            <b-card :id="'__q' + items.questionnumber" no-body class="mx-lg-4 pt-4 pb-3 border-0">
              <b-row no-gutters class="align-items-center">
                <div class="col-xl-3 col-lg-3 col-12 pt-4 pb-2 p-lg-0 order-lg-1 order-3">
                  <div
                    class="d-flex align-items-center justify-content-start justify-content-lg-end mt-lg-auto my-2 ml-3 mb-lg-0 pl-3 pl-md-5 pl-lg-4">
                    <!-- circle choice -->
                    <div class="ansIcon d-flex flex-column mx-1" v-for="(j, index2) in items.sel"
                      :key="index2" :class="{ active:(conselectedAns[items.questionnumber - 1]==j.value),
                isFinish:finish2 && ShowCorrectAns(AllAns[items.questionnumber - 1].ans, j.value),
                ishoverSel:(ishover.index === items.questionnumber - 1)&&(ishover.index2 === index2) && (ishover.status === true)
                }">
                      <template>
                        <button :id="'btn_'+index2+'_off'"
                          class="border-0 btn-ansertool btn p-0 shadow-sm rounded-circle d-flex flex-fill justify-content-center align-items-center"
                          @mouseover="overEvent(items.questionnumber, index2, true)"
                          @mouseleave="leaveEvent(items.questionnumber, index2, false)" @click="selectAns(items.questionnumber,
                          j.value, AllAns[items.questionnumber - 1].group)"
                          style="width:39px;height:40px;"
                          :class="{
                  'right':finish2 && ShowCorrectAns(AllAns[items.questionnumber - 1].ans, j.value)&&(conselectedAns[items.questionnumber - 1]===j.value),
                  'text-white':(!allwaysAns && conselectedAns[items.questionnumber - 1]==j.value&&(!finish2||AllAns[items.questionnumber - 1].ans.indexOf(conselectedAns[items.questionnumber - 1]) === -1))||((allwaysAns&&conselectedAns[items.questionnumber - 1] === j.value))&&(AllAns[items.questionnumber - 1].ans.indexOf(conselectedAns[items.questionnumber - 1])=== -1),
                  'text-white':finish2 && ShowCorrectAns(AllAns[items.questionnumber - 1].ans, j.value)&&(AllAns[items.questionnumber - 1].ans.indexOf(conselectedAns[items.questionnumber - 1]) === -1),
                  'right border-w-5':(selectedStatus[items.questionnumber - 1]&&(AllAns[items.questionnumber - 1].ans.indexOf(j.value)!== -1))&&(allwaysAns&&conselectedAns[items.questionnumber - 1] === j.value),
                  'right border-w-3':allwaysAns &&((conselectedShowStatus[items.questionnumber - 1]&&(AllAns[items.questionnumber - 1].ans.indexOf(j.value)!== -1))||(selectedStatus[items.questionnumber - 1]&&(AllAns[items.questionnumber - 1].ans.indexOf(j.value)!== -1)&&(AllAns[items.questionnumber - 1].ans.indexOf(conselectedAns[items.questionnumber - 1])=== -1)))}">
                          
                          <span
                            v-if="((allwaysAns&&conselectedAns[items.questionnumber - 1] === j.value))&&(AllAns[items.questionnumber - 1].ans.indexOf(conselectedAns[items.questionnumber - 1])=== -1)"
                            class="position-absolute text-danger mt-n1">
                            <font-awesome-icon :icon="['fas', 'times']" style="font-size:3.5rem" />
                          </span>
                          <span class="position-absolute text-success mt-n1" 
                            v-else-if="(selectedStatus[items.questionnumber - 1]&&(AllAns[items.questionnumber - 1].ans.indexOf(j.value)!== -1))&&(allwaysAns&&conselectedAns[items.questionnumber - 1] === j.value)">
                            <font-awesome-icon :icon="['fas', 'check']" style="font-size:3.5rem" />
                          </span>
                          <span
                            v-if="(finish2&& !allwaysAns && conselectedAns[items.questionnumber - 1]==j.value&&(!finish2||AllAns[items.questionnumber - 1].ans.indexOf(conselectedAns[items.questionnumber - 1]) === -1))"
                            class="position-absolute text-danger mt-n1">
                            <font-awesome-icon :icon="['fas', 'times']" style="font-size:3.5rem" />
                          </span>
                          <span class="position-absolute text-success mt-n1" v-else-if="finish2 && ShowCorrectAns(AllAns[items.questionnumber - 1].ans, j.value)&&(conselectedAns[items.questionnumber - 1]===j.value)">
                            <font-awesome-icon :icon="['fas', 'check']" style="font-size:3.5rem" />
                          </span>
                        </button>

                      </template>
                    </div>
                    <!-- circle mark -->
                    <div class="ansIcon">
                      <div :id="'tooltip-target-'+item.questionnumber" :class="{'text-danger':questionTag_clone[item.questionnumber - 1],
                  'text-secondary':!questionTag_clone[item.questionnumber - 1]}"
                        class=" mx-1 d-flex justify-content-center align-items-center"
                        @click="tagQuestion(item.questionnumber)" style="width:40px;height:40px;">
                        <font-awesome-icon :icon="['fas', 'question-circle']"
                          class="d-inline-block mt-n1" style="font-size:1.25rem" />
                      </div>
                      <b-tooltip :target="'tooltip-target-'+item.questionnumber" triggers="hover"
                        placement="bottom">
                       保留作答
                      </b-tooltip>
                    </div>
                  </div>
                </div>
                <div class="col-xl-9 col-lg-9 col-12 order-lg-2 order-1">
                  <div class="row no-gutters">
                    <div class="col-12">
                      <b-card-body>
                        <b-card-text id="qTitle">
                          <!-- {{ `${index + 1}.${items.title}` }} -->
                          <div class="d-flex">
                            <div class="question_number text-right pr-lg-2 flex-shrink-0">
                              {{items.questionnumber}}.</div>
                            <div class="pr-lg-5">
                              <div class="text-justify" v-html="`${items.title}`"></div>
                              <small class="notes" v-if="getshowinfoquestion(items)"
                                v-html="items.notes_title"></small>
                            </div>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </div>
                  </div>
                </div>
                <div class="col-xl-9 col-lg-9 offset-lg-3 col-12 order-lg-3 order-2">
                  <div class="row no-gutters">
                    <div class="col-12">
                      <b-card-body class="pt-0 pb-0">
                        <b-card-text class="qChoice pr-lg-5">
                          <!-- {{ `${index + 1}.${items.title}` }} -->
                          <div class="d-flex">
                            <div class="flex-fill" :class="{'bg-status':finish2||allwaysAns}">
                              <div class="questionAll" v-for="(i, index3) in items.sel"
                                :key="index3"
                                :class="{active:conselectedAns[items.questionnumber - 1]===i.value,
                        isFinish:finish2 && ShowCorrectAns(AllAns[items.questionnumber - 1].ans,i.value),
                        ishoverSel:(ishover.index === items.questionnumber - 1)&&(ishover.index2 === index3) && (ishover.status === true)}"
                                @mouseover="overEvent(items.questionnumber, index3, true)"
                                @mouseleave="leaveEvent(items.questionnumber, index3, false)">
                                <div class="my-1 py-1" @click="selectAns(items.questionnumber,
                        i.value, AllAns[index].group)"
                                :class="{'bg-deepred text-white':(allwaysAns||finish2&&!allwaysAns)&&((conselectedShowStatus[items.questionnumber - 1]&&(AllAns[items.questionnumber - 1].ans.indexOf(i.value)!== -1))||(selectedStatus[items.questionnumber - 1]&&(AllAns[items.questionnumber - 1].ans.indexOf(i.value)!== -1)&&(AllAns[items.questionnumber - 1].ans.indexOf(conselectedAns[items.questionnumber - 1])=== -1)))
                                ,'bg-lightgreen':(selectedStatus[items.questionnumber - 1]&&(AllAns[items.questionnumber - 1].ans.indexOf(i.value)!== -1))&&((allwaysAns||finish2&&!allwaysAns)&&conselectedAns[items.questionnumber - 1] === i.value)}">
                                  <!-- {{items.selectq}} - {{i.value}} -->
                                  <!-- {{ `（${i.value}）${i.name}` }} -->
                                  
                                  <div class="d-flex align-items-start position-relative">
                                    <font-awesome-icon
                                      v-if="(!allwaysAns&&(finish2 && !ShowCorrectAns(AllAns[items.questionnumber - 1].ans,i.value)&&conselectedAns[items.questionnumber - 1] === i.value))||((allwaysAns&&conselectedAns[items.questionnumber - 1] === i.value))&&(AllAns[items.questionnumber - 1].ans.indexOf(conselectedAns[items.questionnumber - 1])=== -1)"
                                      class="text-secondary position-absolute"
                                      :icon="['fas', 'times']"
                                      style="font-size:1.5rem;right:8px;bottom: 0;opacity:0.4" />
                                    <div class="pr-1">({{i.value}})</div>
                                    <div class="text-justify" v-html="`${i.name}`">

                                    </div>
                                  </div>
                                  <small class="notes" v-if="getshowinfoquestion(items)"
                                    v-html="i.notes"></small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </div>
                  </div>
                </div>
                <div class="col-xl-9 col-lg-9 offset-lg-3 col-12 order-lg-4 order-4">

                  <div class="row no-gutters">
                    <!-- 功能工具-->
                    <div class="col-12 d-flex flex-wrap align-items-center py-0">
                      <div v-if="single"
                        class="position-fixed pl-4 ml-md-4 d-flex px-3 justify-content-end justify-content-md-end justify-content-lg-start justify-content-sm-end">
                        <div>
                          <button type="button" class="btn btn-primary mr-2"
                            @click="lessQ(items.questionnumber)" :disabled="qkey === 1"> 上一題
                          </button>
                        </div>
                        <div>
                          <button type="button" class="btn btn-primary"
                            @click="addGroupQ(index, items.questionnumber)"
                            v-if="proqkey2<totalQuestion">下一題</button>
                        </div>
                      </div>
                      <div class="ml-auto px-3 px-md-5 mt-2">
                            <div class="d-inline-block pr-3" v-if='(allwaysAns||finish2&&!allwaysAns)&&items.notes_title'>
                              <button class='btn btn-link p-0' @click='showquestion(items)'>
                                {{getshowinfoquestion(items)?"關閉解析":"觀看解析"}}</button>
                            </div>
                        <template v-if="allwaysAns || finish2 && qa_method==='VIP'">
                          <button v-b-tooltip.hover.bottom title="看答案" v-if="allwaysAns"
                            class="mybtn bg-white btn btn-outline-secondary mx-1"
                            @click="showAns(items.questionnumber)"
                            :class="{'active':conselectedShowStatus[items.questionnumber - 1]}">
                            <font-awesome-icon :icon="['fas', 'eye']" />
                          </button>
                          <button v-b-tooltip.hover.bottom title="看解析"
                            v-if="$route.params.examId.substr(2, 1) === '2'"
                            class="mybtn bg-white btn btn-outline-secondary mx-1"
                            :class="{active:showDetial||conselectedShowDetial[items.questionnumber - 1]}"
                            @click="showDetial_status?showDetial_status = false : showDetial_status = true,sohwDetial_method(items.questionnumber - 1, true)">
                            <font-awesome-icon :icon="['fas', 'question']" />
                          </button>
                        </template>
                        <button v-b-tooltip.hover.bottom title="錯誤回報" v-if="qa_method==='VIP'"
                          v-b-modal.modal-center @click="errorSubmit(items)"
                          class="mybtn bg-white btn btn-outline-secondary mx-1">
                          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                        </button>
                        <button v-b-tooltip.hover.bottom title="修改題目"
                          v-if="qa_method==='VIP'&&userinfo.Authority" v-b-modal.modal-center2
                          @click="modifyQuestions(items)"
                          class="mybtn bg-white btn btn-outline-secondary mx-1">
                          <font-awesome-icon :icon="['fas', 'tools']" />
                        </button>
                      </div>
                    </div>

                    <template v-if="showDetial||conselectedShowDetial[items.questionnumber - 1]">
                      <div class="col-12 d-flex align-items-center justify-content-center p-3">
                        <div v-if="items.unit_code.status !== null"
                          class="d-flex border bg-light rounded flex-fill p-3 align-items-start">
                          <div>命題範圍:</div>
                          <div class="ml-3 text-dark">
                            《<a href="https://www.magee.tw/product/goodsmore/707"
                              target="_blank">絕對考上導遊＋領隊
                              有聲書</a>》
                            <div class="ml-3">
                              <span>{{(items.unit_code.type=='A')? "第 1 冊 - 實務一&觀光資源概要":
                              (items.unit_code.type=='B')? "第 2 冊 - 實務二":"第 3 冊 - 領隊別冊"}}<br></span>
                              <span>CH
                                {{items.unit_code.code.substr(1, 1)}}　{{items.unit_code.name}}</span>
                              <span class="ml-2"> § {{items.subject_code.name}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="false"
                        class="col-12 d-flex flex-column align-items-start justify-content-start p-3">
                        <div class="AnalyzeNav d-flex w-25 justify-content-between">
                          <div class="d-flex flex-fill justify-content-center align-items-center"
                            @click="AnalyzeType = 'student', ChangeAnalyzeType(items.questionnumber, AnalyzeType)"
                            :class="{active:AnalyzeTypeList[items.questionnumber - 1] === 'student'}">
                            <span>考生解題</span>
                            <b-badge variant="primary" class="rounded-circle ml-2">
                              {{msgAnalyzeTemp[1]['student'].length}}</b-badge>
                          </div>
                          <div class="d-flex flex-fill justify-content-center align-items-center"
                            @click="AnalyzeType = 'admin', ChangeAnalyzeType(items.questionnumber, AnalyzeType)"
                            :class="{active:AnalyzeTypeList[items.questionnumber - 1] === 'admin'}">
                            <span>站長解題</span>
                            <b-badge variant="primary" class="rounded-circle ml-2">
                              {{msgAnalyzeTemp[1]['admin'].length}}</b-badge>
                          </div>
                        </div>
                        <div class="d-flex flex-column w-100">
                          <div
                            v-for="(i, keys) in msgAnalyzeTemp[1][AnalyzeTypeList[items.questionnumber - 1]]"
                            :key="keys" class="d-flex flex-column border mx-1 mt-2 p-2 bg-white">
                            <div class="d-flex flex-fill flex-column justify-content-center">
                              <div class="d-flex flex-fill justify-content-start">
                                <b-avatar :src="i.img"></b-avatar>
                                <div class="d-flex flex-column align-items-start ml-2">
                                  <span v-if="i.isBest"
                                    class="bg-danger p-1 rounded text-white">最佳解析</span>
                                  <div class="d-flex">
                                    <span>{{i.name}}</span>
                                    <span class="ml-2">{{i.level}}</span>
                                  </div>
                                </div>
                                <div class="d-flex ml-auto align-items-end">
                                  <small>{{i.date}}</small>
                                  <small class="ml-3">{{keys + 1 }} 樓</small>
                                </div>
                              </div>
                              <hr />
                              <div class="d-flex justify-content-between">
                                <div class="ml-5">
                                  {{i.text}}
                                </div>
                                <div class="d-flex">
                                  <span class="mx-1">
                                    <font-awesome-icon :icon="['fa', 'thumbs-up']" />
                                    {{i.thumbs_up}}</span>
                                  <span class="mx-1">
                                    <font-awesome-icon :icon="['fa', 'thumbs-down']" />
                                    {{i.thumbs_down}}</span>
                                  <small class="mx-1"><a href="#" @click.prevent>檢舉</a></small>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div v-if="AnalyzeType === 'student'"
                            class="d-flex flex-column border mx-1 mt-2 p-2 bg-white">
                            <div>
                              <b-textarea></b-textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </b-row>
            </b-card>
            <!-- =========================== -->
          </div>
        </b-row>
      </b-card>
      <b-card v-if="!item.fill&&!item.read" :id="'__q' + item.questionnumber" no-body
        class="mx-lg-4 py-3 border-0">
        <b-row no-gutters class="align-items-center">
          <div class="col-xl-3 col-lg-3 col-12 pt-4 pb-2 p-lg-0 order-lg-1 order-3">
            <div
              class="d-flex align-items-center justify-content-start justify-content-lg-end mt-lg-auto my-2 ml-3 mb-lg-0 pl-3 pl-md-5 pl-lg-4">
              <!-- circle choice -->
              <div class="ansIcon d-flex flex-column mx-1" v-for="(j, index2) in item.sel"
                :key="index2" :class="{ active:(conselectedAns[item.questionnumber - 1]==j.value),
                isFinish:finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans, j.value),
                ishoverSel:(ishover.index === item.questionnumber - 1)&&(ishover.index2 === index2) && (ishover.status === true)
                }">
                <template>
                  <button :id="'btn_'+index2+'_off'"
                    class="btn-ansertool btn p-0 shadow-sm rounded-circle d-flex flex-fill justify-content-center align-items-center"
                    @mouseover="overEvent(item.questionnumber, index2, true)"
                    @mouseleave="leaveEvent(item.questionnumber, index2, false)" @click="selectAns(item.questionnumber,
                          j.value, AllAns[item.questionnumber - 1].group)"
                    style="width:39px;height:40px;"
                    :class="{
                  'right':finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans, j.value)&&(conselectedAns[item.questionnumber - 1]===j.value),
                  'text-white':(!allwaysAns && conselectedAns[item.questionnumber - 1]==j.value&&(!finish2||AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1]) === -1))||((allwaysAns&&conselectedAns[item.questionnumber - 1] === j.value))&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1),
                  'text-white':finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans, j.value)&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1]) === -1),
                  'right border-w-5':(selectedStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(j.value)!== -1))&&(allwaysAns&&conselectedAns[item.questionnumber - 1] === j.value),
                  'right border-w-3':allwaysAns &&((conselectedShowStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(j.value)!== -1))||(selectedStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(j.value)!== -1)&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1)))}">
                    <span
                      v-if="((allwaysAns&&conselectedAns[item.questionnumber - 1] === j.value))&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1)"
                      class="position-absolute text-danger mt-n1">
                      <font-awesome-icon :icon="['fas', 'times']" style="font-size:3.5rem" />
                    </span>
                    <span class="position-absolute text-success mt-n1" 
                      v-else-if="(selectedStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(j.value)!== -1))&&(allwaysAns&&conselectedAns[item.questionnumber - 1] === j.value)">
                      <font-awesome-icon :icon="['fas', 'check']" style="font-size:3.5rem" />
                    </span>
                    <span
                      v-if="(finish2&& !allwaysAns && conselectedAns[item.questionnumber - 1]==j.value&&(!finish2||AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1]) === -1))"
                      class="position-absolute text-danger mt-n1">
                      <font-awesome-icon :icon="['fas', 'times']" style="font-size:3.5rem" />
                    </span>
                    <span class="position-absolute text-success mt-n1" v-else-if="finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans, j.value)&&(conselectedAns[item.questionnumber - 1]===j.value)">
                      <font-awesome-icon :icon="['fas', 'check']" style="font-size:3.5rem" />
                    </span>
                  </button>

                </template>
              </div>
              <!-- circle mark -->
              <div class="ansIcon">
                <div :id="'tooltip-target-'+item.questionnumber" :class="{'text-danger':questionTag_clone[item.questionnumber - 1],
                  'text-secondary':!questionTag_clone[item.questionnumber - 1]}"
                  class=" mx-1 d-flex justify-content-center align-items-center"
                  @click="tagQuestion(item.questionnumber)" style="width:40px;height:40px;">
                  <font-awesome-icon :icon="['fas', 'question-circle']" class="d-inline-block mt-n1"
                    style="font-size:1.25rem" />
                </div>
                <b-tooltip :target="'tooltip-target-'+item.questionnumber" triggers="hover"
                  placement="bottom">
                 保留作答
                </b-tooltip>
              </div>
            </div>
          </div>
          <div class="col-xl-9 col-lg-9 col-12 order-lg-2 order-1">
            <div class="row no-gutters">
              <div class="col-12">
                <b-card-body>
                  <b-card-text id="qTitle">
                    <!-- {{ `${index + 1}.${item.title}` }} -->
                    <div class="d-flex">
                      <div class="question_number text-right pr-lg-2 flex-shrink-0">
                        {{item.questionnumber}}.</div>
                      <div class="pr-lg-5">
                        <div class="text-justify" v-html="`${item.title}`"></div>
                        <small class="notes" v-if="getshowinfoquestion(item)"
                          v-html="item.notes_title"></small>
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
              </div>
            </div>
          </div>
          <div class="col-xl-9 col-lg-9 offset-lg-3 col-12 order-lg-3 order-2">
            <div class="row no-gutters">
              <div class="col-12">
                <b-card-body class="pt-0 pb-0">
                  <b-card-text class="qChoice pr-lg-5">
                    <!-- {{ `${index + 1}.${item.title}` }} -->
                    <div class="d-flex">
                      <div class="flex-fill" :class="{'bg-status':finish2||allwaysAns}">
                        <div class="questionAll" v-for="(i, index3) in item.sel" :key="index3"
                          :class="{active:conselectedAns[item.questionnumber - 1]===i.value,
                        isFinish:finish2 && ShowCorrectAns(AllAns[item.questionnumber - 1].ans,i.value),
                        ishoverSel:(ishover.index === item.questionnumber - 1)&&(ishover.index2 === index3) && (ishover.status === true)}"
                          @mouseover="overEvent(item.questionnumber, index3, true)"
                          @mouseleave="leaveEvent(item.questionnumber, index3, false)">
                          <div class="my-1 py-1" @click="selectAns(item.questionnumber,
                        i.value, AllAns[index].group)"
                            :class="{'bg-deepred text-white':(allwaysAns||finish2&&!allwaysAns)&&((conselectedShowStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(i.value)!== -1))||(selectedStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(i.value)!== -1)&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1)))
                            ,'bg-lightgreen':(selectedStatus[item.questionnumber - 1]&&(AllAns[item.questionnumber - 1].ans.indexOf(i.value)!== -1))&&((allwaysAns||finish2&&!allwaysAns)&&conselectedAns[item.questionnumber - 1] === i.value)}">
                            <!-- {{allwaysAns}} / 完成 {{finish2}} -->
                            <div class="d-flex align-items-start position-relative">
                              <!-- <font-awesome-icon
                                v-if="(!allwaysAns&&(finish2 && !ShowCorrectAns(AllAns[item.questionnumber - 1].ans,i.value)&&conselectedAns[item.questionnumber - 1] === i.value))||((allwaysAns&&conselectedAns[item.questionnumber - 1] === i.value))&&(AllAns[item.questionnumber - 1].ans.indexOf(conselectedAns[item.questionnumber - 1])=== -1)"
                                class="text-secondary position-absolute" :icon="['fas', 'times']"
                                style="font-size:1.5rem;right:8px;bottom: 0;opacity:0.4" /> -->
                              <div class="pr-1">({{i.value}})</div>
                              <div class="text-justify" v-html="`${i.name}`">

                              </div>
                            </div>
                            <small class="notes" v-if="getshowinfoquestion(item)"
                              v-html="i.notes"></small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
              </div>
            </div>
          </div>
          <div class="col-xl-9 col-lg-9 offset-lg-3 col-12 order-lg-4 order-4">

            <div class="row no-gutters">

              <!-- 功能工具-->
              <div class="col-12 d-flex flex-wrap align-items-center py-0">
                <div
                  class="pl-4 ml-md-4 d-inline-flex px-3 justify-content-end justify-content-md-end justify-content-lg-start justify-content-sm-end">
                  <div v-if="single">
                    <button type="button" class="btn btn-primary mr-2" @click="lessQ(item.questionnumber)"
                      :disabled="qkey === 1">上一題 </button>
                  </div>
                  <div v-if="single">
                    <button type="button" class="btn btn-primary"
                      @click="addGroupQ(index, item.questionnumber)"
                      v-if="proqkey2<totalQuestion">下一題</button>
                  </div>
                </div>
                <div class="ml-auto px-3 px-md-5 mt-2">
                  <div class='d-inline-block pr-3' v-if='(allwaysAns||finish2&&!allwaysAns)&&item.notes_title'>
                        <button class='btn btn-link p-0' @click='showquestion(item)'>
                          {{getshowinfoquestion(item)?"關閉解析":"觀看解析"}}</button>
                      </div>
                  <template v-if="allwaysAns || finish2 && qa_method==='VIP'">
                    <button v-b-tooltip.hover.bottom title="看答案" v-if="allwaysAns"
                      class="mybtn bg-white btn btn-outline-secondary border-0 rounded-circle shadow-sm mx-1"
                      @click="showAns(item.questionnumber)"
                      :class="{'active':conselectedShowStatus[item.questionnumber - 1]}">
                      <font-awesome-icon :icon="['fas', 'eye']" />
                    </button>
                    <button v-b-tooltip.hover.bottom title="看解析"
                      v-if="$route.params.examId.substr(2, 1) === '2'"
                      class="mybtn bg-white btn btn-outline-secondary border-0 rounded-circle shadow-sm mx-1"
                      :class="{active:showDetial||conselectedShowDetial[item.questionnumber - 1]}"
                      @click="showDetial_status?showDetial_status = false : showDetial_status = true,sohwDetial_method(item.questionnumber - 1, true)">
                      <font-awesome-icon :icon="['fas', 'question']" />
                    </button>
                  </template>
                  <button v-b-tooltip.hover.bottom title="錯誤回報" v-if="qa_method==='VIP'"
                    v-b-modal.modal-center @click="errorSubmit(item)"
                    class="mybtn bg-white btn btn-outline-secondary border-0 rounded-circle shadow-sm mx-1">
                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                  </button>
                  <button v-b-tooltip.hover.bottom title="修改題目"
                    v-if="qa_method==='VIP'&&userinfo.Authority" v-b-modal.modal-center2
                    @click="modifyQuestions(item)"
                    class="mybtn bg-white btn btn-outline-secondary border-0 rounded-circle shadow-sm mx-1">
                    <font-awesome-icon :icon="['fas', 'tools']" />
                  </button>
                </div>
              </div>

              <template v-if="showDetial||conselectedShowDetial[item.questionnumber - 1]">
                <div class="col-12 d-flex align-items-center justify-content-center p-3">
                  <div v-if="item.unit_code.status !== null"
                    class="d-flex border bg-light rounded flex-fill p-3 align-items-start">
                    <div>命題範圍:</div>
                    <div class="ml-3 text-dark">
                      《<a href="https://www.magee.tw/product/goodsmore/707"
                        target="_blank">絕對考上導遊＋領隊
                        有聲書</a>》
                      <div class="ml-3">
                        <span>{{(item.unit_code.type=='A')? "第 1 冊 - 實務一&觀光資源概要":
                              (item.unit_code.type=='B')? "第 2 冊 - 實務二":"第 3 冊 - 領隊別冊"}}<br></span>
                        <span>CH {{item.unit_code.code.substr(1, 1)}}　{{item.unit_code.name}}</span>
                        <span class="ml-2"> § {{item.subject_code.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="false"
                  class="col-12 d-flex flex-column align-items-start justify-content-start p-3">
                  <div class="AnalyzeNav d-flex w-25 justify-content-between">
                    <div class="d-flex flex-fill justify-content-center align-items-center"
                      @click="AnalyzeType = 'student', ChangeAnalyzeType(item.questionnumber, AnalyzeType)"
                      :class="{active:AnalyzeTypeList[item.questionnumber - 1] === 'student'}">
                      <span>考生解題</span>
                      <b-badge variant="primary" class="rounded-circle ml-2">
                        {{msgAnalyzeTemp[1]['student'].length}}</b-badge>
                    </div>
                    <div class="d-flex flex-fill justify-content-center align-items-center"
                      @click="AnalyzeType = 'admin', ChangeAnalyzeType(item.questionnumber, AnalyzeType)"
                      :class="{active:AnalyzeTypeList[item.questionnumber - 1] === 'admin'}">
                      <span>站長解題</span>
                      <b-badge variant="primary" class="rounded-circle ml-2">
                        {{msgAnalyzeTemp[1]['admin'].length}}</b-badge>
                    </div>
                  </div>
                  <div class="d-flex flex-column w-100">
                    <div
                      v-for="(i, keys) in msgAnalyzeTemp[1][AnalyzeTypeList[item.questionnumber - 1]]"
                      :key="keys" class="d-flex flex-column border mx-1 mt-2 p-2 bg-white">
                      <div class="d-flex flex-fill flex-column justify-content-center">
                        <div class="d-flex flex-fill justify-content-start">
                          <b-avatar :src="i.img"></b-avatar>
                          <div class="d-flex flex-column align-items-start ml-2">
                            <span v-if="i.isBest"
                              class="bg-danger p-1 rounded text-white">最佳解析</span>
                            <div class="d-flex">
                              <span>{{i.name}}</span>
                              <span class="ml-2">{{i.level}}</span>
                            </div>
                          </div>
                          <div class="d-flex ml-auto align-items-end">
                            <small>{{i.date}}</small>
                            <small class="ml-3">{{keys + 1 }} 樓</small>
                          </div>
                        </div>
                        <hr />
                        <div class="d-flex justify-content-between">
                          <div class="ml-5">
                            {{i.text}}
                          </div>
                          <div class="d-flex">
                            <span class="mx-1">
                              <font-awesome-icon :icon="['fa', 'thumbs-up']" />
                              {{i.thumbs_up}}</span>
                            <span class="mx-1">
                              <font-awesome-icon :icon="['fa', 'thumbs-down']" />
                              {{i.thumbs_down}}</span>
                            <small class="mx-1"><a href="#" @click.prevent>檢舉</a></small>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div v-if="AnalyzeType === 'student'"
                      class="d-flex flex-column border mx-1 mt-2 p-2 bg-white">
                      <div>
                        <b-textarea></b-textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </b-row>
      </b-card>
    </div>
    <div class="question-info my-3 mt-lg-3 mb-lg-5 text-center" v-if="!finish2">
      <b-button class="ml-auto" v-if="!allwaysAns&&!finish2" variant="danger" size="lg"
        @click="showMsgBoxOne">
        <font-awesome-icon :icon="['fas', 'scroll']" class="mr-1" />
        我要交卷
      </b-button>
    </div>
    <!-- reprot form -->
    <b-modal id="modal-center" size="lg" centered title="錯誤回報" footer-class="border-0 pt-0" ok-title="送出" cancel-variant="light" cancel-title="放棄">
      <div class="row">
        <div class="col-12">
          <b-card class="border-0">
            <b-row no-gutters>
              <div class="col-12">
                <b-card-body body-class="p-0">
                  <h6 class="mb-1 d-block text-deepgold letter-s-1 font-weight-bold">
              {{`${$route.params.year} 年度${toZh[$route.params.examId.substr(0, 1)].name}${toZh[$route.params.examId.substr(1, 1)].name} ‧ ${toZh[$route.params.examId.substr(2, 1)].name}`}}
                  </h6>
                  <b-card-text id="qTitle">
                    <div class="text-deepgold">第{{ErrorQuestionTemp.questionnumber}}題</div>
                    <div v-html="ErrorQuestionTemp.title"></div>
                  </b-card-text>
                  <div class="questionAll mb-3" v-for="(item, jindex) in ErrorQuestionTemp.sel"
                    :key="jindex">
                    <b-card-text>
                      <div v-html="`(${item.value})${item.name}`"></div>
                    </b-card-text>
                  </div>
                  <b-card-text>{{`正確答案：${ErrorQuestionTemp.ans}`}}</b-card-text>
                </b-card-body>
              </div>
            </b-row>
          </b-card>
        </div>
        <div class="col-12">
          <b-card class="border-right-0 border-bottom-0 border-left-0 rounded-0" body-class="p-0">
            <b-row no-gutters>
              <div class="col-12">
                <b-card-body>
                  <b-card-text id="qTitle">
                    <div class="text-deepgold">錯誤描述</div>
                  </b-card-text>
                  <div class="form-group">
                    <textarea class="form-control" name="errMsg" id="errMsg" rows="3"
                      v-model="errMsg" placeholder="請寫下題目/選項/答案錯誤原因？"></textarea>
                  </div>
                </b-card-body>
              </div>
            </b-row>
          </b-card>
        </div>
      </div>
    </b-modal>
    <!-- admin fix form  -->
    <b-modal id="modal-center2" size="lg" centered title="修改題目" header-text-variant="white"
      header-bg-variant="primary" ok-title="儲存" cancel-title="放棄">
      <!--
      <template slot="modal-header">
        <div class="d-flex flex-fill justify-content-start align-items-center p-3" style="background:rgb(3, 71, 160) !important;">
          <h4 class="text-white">修改題目</h4>
        </div>
      </template>
      -->
      <div class="row">
        <div class="col-12">
          <b-card class="border-0">
            <b-row no-gutters>
              <div class="col-12">
                <b-card-body>
                  <b-card-text id="qTitle">
                    <div class="form-group mt-3">
                      <h6 class="font-weight-bold">
                        {{`第${ModifyQuestionTemp.questionnumber}題題目：`}}
                      </h6>
                      <textarea class="form-control" name id rows="3"
                        v-model="ModifyQuestionTemp.title"></textarea>
                      <h6 class="mt-3 font-weight-bold">
                        題目提示：
                      </h6>
                      <textarea class="form-control" name id rows="3"
                        v-model="ModifyQuestionTemp.notes_title"></textarea>
                    </div>
                  </b-card-text>
                  <div class="questionAll" v-for="(item, jindex) in ModifyQuestionTemp.sel"
                    :key="jindex">
                    <b-card-text>
                      <!-- <div v-html="`（${item.value}）${item.name}`"></div> -->
                      <div class="row">
                        <div class="col-3 mt-2">
                          <label for="input-small">{{`選項（${item.value}）：`}}</label>
                        </div>
                        <div class="col-9 mt-2">
                          <b-form-input name="input-small" size="sm" v-model="item.name">
                          </b-form-input>
                        </div>
                        <div class="col-3 mt-2">
                          <label for="input-small">{{`選項（${item.value}）提示：`}}</label>
                        </div>
                        <div class="col-9 mt-2">
                          <b-form-input name="input-small" size="sm" v-model="item.notes">
                          </b-form-input>
                        </div>
                      </div>
                    </b-card-text>
                  </div>
                  <div class="questionAll mt-2">
                    <div class="row">
                      <div class="col-3 mt-2">
                        <label for="input-small">正確答案：</label>
                      </div>
                      <div class="col-9 mt-2">
                        <b-form-checkbox-group v-model="ModifyQuestionTemp.ans" name="modifyAns">
                          <b-form-checkbox value="A">A</b-form-checkbox>
                          <b-form-checkbox value="B">B</b-form-checkbox>
                          <b-form-checkbox value="C">C</b-form-checkbox>
                          <b-form-checkbox value="D">D</b-form-checkbox>
                        </b-form-checkbox-group>
                      </div>
                    </div>
                  </div>
                </b-card-body>
              </div>
            </b-row>
          </b-card>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import ctrl from './js/ComQuestions';

  export default ctrl;

</script>

<style lang="scss">

</style>
